import axios from "axios";
import { message } from "antd";
import { trackPromise } from "react-promise-tracker";
import K from "utilities/constants";
import { camelCaseKeys } from "utilities/generalUtility";
import User from "redux/models/user";

const { Unauthorized, Forbidden } = K.Network.StatusCode;

export default class NetworkCall {
  static async fetch(
    request,
    useLoading = true,
    showError = true,
    skipForbiddenRedirect = false,
  ) {
    try {
      const response = useLoading
        ? await trackPromise(
            NetworkCall.axios({
              method: request.method,
              url: request.url,
              data: request.body,
              headers: request.headers,
              responseType: request.responseType,
              validateStatus: (status) => {
                return (
                  (status >= 200 && status < 300) ||
                  status === K.Network.StatusCode.NotModified
                );
              },
            }),
          )
        : await NetworkCall.axios({
            method: request.method,
            url: request.url,
            data: request.body,
            headers: request.headers,
            responseType: request.responseType,
            validateStatus: (status) => {
              return (
                (status >= 200 && status < 300) ||
                status === K.Network.StatusCode.NotModified
              );
            },
          });

      console.log("NetworkCall Data: ", response.data.data);
      return response.data;
    } catch (err) {
      const error = err.response;
      console.log("NetworkCall Error: ", error);
      if (error === undefined) {
        if (showError) message.error("Cannot connect to server");
        return Promise.reject({
          error,
        });
      }

      const skipRedirect = request.url?.includes(K.Network.URL.Auth.Login);

      if (error.status === Unauthorized && !skipRedirect) {
        User.logoutCall("User unauthorized");
      } else if (
        error.status === Forbidden &&
        !skipRedirect &&
        !skipForbiddenRedirect
      ) {
        window.location.replace("/unauthorized");
      } else if (showError) message.error(error.data.message);

      if ("errors" in error.data) {
        error.data.errors = camelCaseKeys(error.data.errors);
      }

      return Promise.reject({
        error,
        message: error.data.message,
        statusCode: error.status,
      });
    }
  }
}
NetworkCall.axios = axios.create({
  baseURL: K.Network.URL.BaseAPI,
  timeout: K.Network.Timeout,
  headers: {},
});
